var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.34 -0.000244141H5.67C2.28 -0.000244141 0 2.37976 0 5.91976V14.0898C0 17.6198 2.28 19.9998 5.67 19.9998H14.34C17.73 19.9998 20 17.6198 20 14.0898V5.91976C20 2.37976 17.73 -0.000244141 14.34 -0.000244141",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52124 8.80347C4.86024 8.80347 4.32324 9.34047 4.32324 9.99947C4.32324 10.6595 4.86024 11.1975 5.52124 11.1975C6.18224 11.1975 6.71924 10.6595 6.71924 9.99947C6.71924 9.34047 6.18224 8.80347 5.52124 8.80347ZM10.0002 8.80347C9.33924 8.80347 8.80224 9.34047 8.80224 9.99947C8.80224 10.6595 9.33924 11.1975 10.0002 11.1975C10.6612 11.1975 11.1982 10.6595 11.1982 9.99947C11.1982 9.34047 10.6612 8.80347 10.0002 8.80347ZM13.2817 9.99947C13.2817 9.34047 13.8187 8.80347 14.4797 8.80347C15.1407 8.80347 15.6777 9.34047 15.6777 9.99947C15.6777 10.6595 15.1407 11.1975 14.4797 11.1975C13.8187 11.1975 13.2817 10.6595 13.2817 9.99947Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc);
export default __webpack_public_path__ + "static/media/etc.ac47dd45b17eb7a2974a841ce5f365d8.svg";
export { ForwardRef as ReactComponent };